import { cn } from '../../lib/utils';

const colClasses = {
  2: 'grid grid-cols-1 gap-4 sm:grid-cols-2',
  3: 'grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3',
  4: 'grid grid-cols-2 gap-4 sm:grid-cols-4',
} as const;

interface CardGridProps {
  cols: 2 | 3 | 4;
  children: React.ReactNode;
  className?: string;
}

export function CardGrid({ cols, children, className }: CardGridProps) {
  return <div className={cn(colClasses[cols], className)}>{children}</div>;
}
